import { render, staticRenderFns } from "./JobCategoriesList.vue?vue&type=template&id=428f80d9&scoped=true"
import script from "./JobCategoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCategoriesList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobCategoriesList.vue?vue&type=style&index=0&id=428f80d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f80d9",
  null
  
)

export default component.exports